import { useNavigate } from "react-router-dom";
import { useActiveAccount } from "@/hooks/useAccounts";
import { useConnectionStatus } from "@/hooks/useConnectionStatus";
import { GlobalClock } from "@/components/GlobalClock";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { useLanguage } from "@/contexts/LanguageContext";

export function ActiveAccountCard() {
  const navigate = useNavigate();
  const { data: account } = useActiveAccount();
  const { status } = useConnectionStatus(account?.id ?? "");
  const { language } = useLanguage();
  const fa = language === "fa";

  if (!account) {
    return (
      <button
        onClick={() => navigate("/account/trading")}
        className="hidden lg:flex items-center h-16 px-4 rounded-md border border-dashed border-border bg-muted/30 text-sm text-muted-foreground hover:bg-muted transition-colors min-w-[220px] justify-center"
      >
        {fa ? "اتصال به بروکر" : "Connect to Broker"}
      </button>
    );
  }

  const isConnected = status === "connected";
  const displayName = account.nickname || account.account_login;

  return (
    <button
      onClick={() => navigate("/account/trading")}
      className="hidden lg:flex flex-col gap-0.5 h-16 px-2.5 py-1.5 rounded-md border border-primary/30 bg-primary/10 hover:bg-primary/15 transition-colors w-fit text-left justify-center overflow-hidden"
    >
      {/* Row 1: displayName + Active label */}
      <div className="flex items-center gap-2 min-w-0">
        <span className="truncate text-foreground leading-none font-bold text-sm text-left">{displayName}</span>
        <span className="text-[10px] font-medium text-primary uppercase tracking-wide shrink-0">
          {fa ? "فعال" : "Active"}
        </span>
      </div>
      {/* Row 2: broker_server + platform badge */}
      <div className="flex items-center gap-2 min-w-0">
        <span className="text-foreground font-semibold leading-none truncate text-xs">
          {account.broker_server}
        </span>
        <Badge variant="outline" className="text-[9px] px-1.5 py-0 h-4 shrink-0">
          {account.platform}
        </Badge>
      </div>
      {/* Row 3: connection status */}
      <span className={cn(
        "flex items-center gap-1 leading-none shrink-0 text-xs font-light",
        isConnected ? "text-emerald-500" : "text-muted-foreground"
      )}>
        <span className={cn(
          "w-1.5 h-1.5 rounded-full inline-block",
          isConnected ? "bg-emerald-500" : "bg-destructive"
        )} />
        {isConnected ? (fa ? "متصل" : "Connected") : (fa ? "قطع" : "Disconnected")}
      </span>
    </button>
  );
}

export const TopBarAccountCluster = () => {
  return (
    <div className="flex items-center gap-3">
      <GlobalClock />
      <ActiveAccountCard />
    </div>
  );
};
